import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line upward reveal for headings
export const MaskedLines = ({ lines, className = "", start = 0, active = true }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          style={{ display: "block" }}
          initial={{ y: "110%" }}
          animate={active ? { y: "0%" } : {}}
          transition={{ duration: 0.9, ease, delay: start + i * 0.11 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
